import langNL from './resources/resource.json';

import { customTranslationsPlugin } from './localizehelpers';


export const translations = {
  nl: langNL,
};

export const i18n = customTranslationsPlugin(translations);

